import { render } from "./PDFDownloaderGroup.vue?vue&type=template&id=1c70d2ab&scoped=true"
import script from "./PDFDownloaderGroup.vue?vue&type=script&lang=js"
export * from "./PDFDownloaderGroup.vue?vue&type=script&lang=js"

import "./PDFDownloaderGroup.vue?vue&type=style&index=0&id=1c70d2ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c70d2ab"]])

export default __exports__